import { Noun } from '../../types'

const долбоёб: Noun = {
  type: 'noun',
  nominativeSingular: 'долбоёб',
  genitiveSingular: 'долбоёба',
  dativeSingular: 'долбоёбу',
  accusativeSingular: 'долбоёба',
  instrumentalSingular: 'долбоёбом',
  prepositionalSingular: 'долбоёбе',
  nominativePlural: 'долбоёбы',
  genitivePlural: 'долбоёбов',
  dativePlural: 'долбоёбам',
  accusativePlural: 'долбоёбов',
  instrumentalPlural: 'долбоёбами',
  prepositionalPlural: 'долбоёбах',
}

export default долбоёб
